import { defineComponent, ref, watchEffect, computed } from "vue";
import { RoomState, chatExtension } from "../chatExtension.mjs";
import { HandleRoomMessage } from "./handleRoomMessage.mjs";
import { useI18n } from "../../locales/index.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "RoomMessageCard",
  props: {
    message: null
  },
  setup(__props) {
    const props = __props;
    const { t } = useI18n();
    const roomCardData = ref({
      roomId: "",
      isRoomMessage: false,
      isRoomCreateByMe: false,
      isMessageFromMe: false,
      roomState: RoomState.CREATING,
      userList: [],
      isInnerRoom: false,
      myProfile: {},
      ownerName: "",
      owner: ""
    });
    const roomMessageCard = new HandleRoomMessage();
    watchEffect(() => {
      roomMessageCard.initialize(props.message);
      const {
        isRoomMessage,
        isRoomCreateByMe,
        roomState,
        userList,
        roomId,
        isInnerRoom,
        myProfile,
        isMessageFromMe,
        ownerName,
        owner
      } = roomMessageCard.messageData;
      roomCardData.value = {
        roomId,
        isRoomMessage,
        isRoomCreateByMe,
        isMessageFromMe,
        roomState,
        userList,
        isInnerRoom,
        myProfile,
        ownerName,
        owner
      };
    });
    const avatarLoadError = (e) => {
      e.target.src = defaultAvatarUrl;
    };
    const contentTitleClass = computed(() => {
      const stateMap = {
        [RoomState.CREATED]: "success",
        [RoomState.CREATING]: "primary",
        [RoomState.DESTROYING]: "default",
        [RoomState.DESTROYED]: "default"
      };
      return stateMap[roomCardData.value.roomState];
    });
    const footerClass = computed(() => {
      const stateMap = {
        [RoomState.CREATED]: "default",
        [RoomState.CREATING]: "center",
        [RoomState.DESTROYING]: "center",
        [RoomState.DESTROYED]: "center"
      };
      return stateMap[roomCardData.value.roomState];
    });
    const roomInfo = computed(() => {
      if (roomCardData.value.roomState === RoomState.CREATING) {
        return {
          visible: true,
          message: `${t("Initiating")}...`
        };
      }
      if (roomCardData.value.isRoomCreateByMe && roomCardData.value.roomState === RoomState.CREATED) {
        return {
          visible: true,
          message: roomCardData.value.userList.length > 1 ? t("X people have joined", {
            number: roomCardData.value.userList.length - 1
          }) : t("Waiting for members to join the meeting")
        };
      }
      if (!roomCardData.value.isRoomCreateByMe && roomCardData.value.roomState === RoomState.CREATED) {
        return {
          visible: true,
          message: t("X people are in the meeting", {
            number: roomCardData.value.userList.length
          })
        };
      }
      return {
        visible: false,
        message: ""
      };
    });
    const roomStatus = computed(() => {
      if (roomCardData.value.roomState === RoomState.CREATED) {
        return {
          visible: true,
          message: roomCardData.value.isInnerRoom ? t("Already joined") : t("Enter the meeting")
        };
      }
      return {
        visible: false,
        message: ""
      };
    });
    const roomDestroy = computed(() => {
      if (roomCardData.value.roomState === RoomState.DESTROYING) {
        return {
          visible: true,
          message: `${t("Ending meeting")}...`
        };
      }
      if (roomCardData.value.roomState === RoomState.DESTROYED) {
        return {
          visible: true,
          message: t("The meeting has ended")
        };
      }
      return {
        visible: false,
        message: ""
      };
    });
    const defaultAvatarUrl = "https://web.sdk.qcloud.com/component/TUIKit/assets/avatar_21.png";
    const enterRoom = () => {
      chatExtension.enterRoom(roomCardData.value.roomId, props.message);
    };
    return { __sfc: true, t, props, roomCardData, roomMessageCard, avatarLoadError, contentTitleClass, footerClass, roomInfo, roomStatus, roomDestroy, defaultAvatarUrl, enterRoom, RoomState };
  }
});
export {
  _sfc_main as default
};
